export default __webpack_public_path__ + "static/media/loaf-cut.ce38df60.png";